export enum MeetingPreference {
    InPerson = 1,
    Phone = 2,
    Virtual = 3
}